import React from 'react';
import './Feedback.css';

const Feedback = () => {
  return (
    <section className="feedback-section" id="feedback">
      <h2 className="feedback-heading">What Our Interns Say</h2>
      <div className="feedback-list">
        {/* Feedback Item 1 */}
        <div className="feedback-item">
          <div className="feedback-content">
            <p className="feedback-message">
              ❝ The real-world projects and constant mentorship made this internship truly enriching. I learned to build scalable systems. ❞
            </p>
            <span className="feedback-author">— Aarav Joshi, MERN Stack Intern</span>
          </div>
        </div>

        {/* Feedback Item 2 */}
        <div className="feedback-item">
          <div className="feedback-content">
            <p className="feedback-message">
              ❝ Weekly coding sprints, real-time collaboration, and impactful feedback helped me grow professionally and personally. ❞
            </p>
            <span className="feedback-author">— Neha Sharma, Backend Intern</span>
          </div>
        </div>

        {/* Feedback Item 3 */}
        <div className="feedback-item">
          <div className="feedback-content">
            <p className="feedback-message">
              ❝ This internship was a game-changer. The exposure to cutting-edge technologies like React and Node.js boosted my career prospects. ❞
            </p>
            <span className="feedback-author">— Ishan Kapoor, Full Stack Intern</span>
          </div>
        </div>

        {/* Feedback Item 4 */}
        <div className="feedback-item">
          <div className="feedback-content">
            <p className="feedback-message">
              ❝ I had the chance to work with a dynamic team, and the hands-on experience with cloud technologies was invaluable for my career. ❞
            </p>
            <span className="feedback-author">— Rina Patel, Cloud Intern</span>
          </div>
        </div>

        {/* Feedback Item 5 */}
        <div className="feedback-item">
          <div className="feedback-content">
            <p className="feedback-message">
              ❝ The mentorship and exposure to industry-best practices were invaluable. This internship helped me enhance my coding skills drastically. ❞
            </p>
            <span className="feedback-author">— Ankit Verma, Java Intern</span>
          </div>
        </div>

        {/* Feedback Item 6 */}
        <div className="feedback-item">
          <div className="feedback-content">
            <p className="feedback-message">
              ❝ The collaborative environment and the challenging tasks helped me grow both technically and personally. I’m grateful for the learning experience. ❞
            </p>
            <span className="feedback-author">— Sanya Mehra, Data Science Intern</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feedback;
